import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './Apps/App';
import { LanguageProvider } from './utils/LanguageContext';
import { CartProvider } from './utils/CartContext'; // ADD THIS LINE

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </LanguageProvider>
  </React.StrictMode>
);